/** Gap between the transcript's top edge and the visual we just revealed. */
export const VISUAL_SCROLL_PADDING_PX = 8;

/**
 * Move `container`'s scroll so `target` sits just below its top edge.
 * Uses the container's own scrollTop, not scrollIntoView, so the page does not move.
 */
export function scrollTranscriptToTarget(container: HTMLElement, target: HTMLElement): void {
  const delta = target.getBoundingClientRect().top - container.getBoundingClientRect().top;
  container.scrollTop += delta - VISUAL_SCROLL_PADDING_PX;
}
